module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "mask",
    staticClass: "modal-mask inmodal",
    style: ({
      height: _vm.maskH,
      top: _vm.pagescroll
    }),
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    style: ({
      width: _vm.width + '%'
    })
  }, [_c('transition', {
    attrs: {
      "name": "modal-container",
      "enter-active-class": "animated bounceInDown",
      "leave-active-class": "animated bounceOutUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('span', {
    staticClass: "header_span"
  }, [_vm._v(_vm._s(_vm.bigTitleMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("bodycontent")], 2)])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb540bd4","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SubPage.vue
// module id = 1627
// module chunks = 0